import React from 'react';
import {NavLink} from "react-router-dom";
import { useTranslation } from "react-i18next";

const FollowUsComponent = () => {
    const { t } = useTranslation();
    
    return (
        <div className="followUsComponent__container">
            <div className="followUsComponent__container-background" style={{ background: `url(${process.env.PUBLIC_URL}/images/contact-background.png)`, backgroundSize: 'cover'}}></div>
            <div className="followUsComponent__container-content-wrap">
                <div className="followUsComponent__container-content">
                    <div className="followUsComponent__container-content-title">
                        <span>{t('main.followUs')}</span>
                    </div>
                    <div className="followUsComponent__container-content-subtitle">
                        <span>{t('main.joinWondrCommunity')}</span>
                    </div>
                    <div className="followUsComponent__container-content-social">
                        <div className="followUsComponent__container-content-social-icon-wrap">
                            <div className="followUsComponent__container-content-social-icon facebook">
                                <NavLink to="https://www.facebook.com/profile.php?id=61555928161386" target="_blank">
                                    <img src={`${process.env.PUBLIC_URL}/images/facebook-icon.svg`} alt="facebook" />
                                </NavLink>
                            </div>
                            <div className="followUsComponent__container-content-social-icon linkedin">
                                <NavLink to="https://www.linkedin.com/in/artsiom-kremenia-4b5841320/" target="_blank">
                                    <img src={`${process.env.PUBLIC_URL}/images/linkedin-icon.svg`} alt="linkedin" />
                                </NavLink>
                            </div>
                            <div className="followUsComponent__container-content-social-icon instagram">
                                <NavLink to="https://www.instagram.com/" target="_blank">
                                    <img src={`${process.env.PUBLIC_URL}/images/instagram-icon.svg`} alt="instagram" />
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FollowUsComponent;